<template>
  <div class="lead-view-left" v-if="Lead && Lead.info">
    <!-- LEAD INFO -->
    <div class="lead-info">
      <div class="lead-brand">
        <div class="lead-brand-content">
          <div class="lead-icon"></div>
          <div class="lead-info-name">{{ Lead.info.lastname }}</div>
          <div class="lead-info-home">
            <a class="lead-clickable-elem-color" :href="Lead.info.autologin">
              <img src="/img/home/t_logo_Fxbullion.com.png">{{ Lead.info.home }}
            </a>
            <span class="lead-info-leadid">{{ Lead.info.login }}</span>
            <div data-login="183365" class="cob-btn">
              <img @click="openCb" data-login="183365" class="cob-btn--item" src="/img/cob.svg">
            </div>
          </div>
          <div class="lead-brand-status-assign-wrap">
            <div class="lead-info-status td--salestatus">
              <div class="ui-ddbox ui-ddbox-select c-1">
                <button class="ui-ddbtn">
                  <span class="ui-ddbtnvalue" @click="isStatusPopup = !isStatusPopup">
                    {{ Lead.info.leadstatus }}
                  </span>
                  <i class="fa fa-caret-down" aria-hidden="true"></i></button>
                <div class="ui-ddbody">
                  <div class="ui-ddsection ui-salestatusList" v-if="App.leadstatus && isStatusPopup">
                    <ul>
                      <li v-for="status in App.leadstatus" :class="{'favor-status' : LeadStatusFavor.includes(status.leadstatus)}"
                          @click="changeLeadStatus(status)">
                        {{ status.leadstatus }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="ui-ddbox ui-ddbox-select">
              <button class="ui-ddbtn">
                <span class="ui-ddbtnvalue"
                      @click="isUsersPopup = !isUsersPopup">
                  {{ Lead.info.user_name }}
                </span>
                <i class="fa fa-caret-down" aria-hidden="true"></i>
              </button>
              <div class="ui-ddbody">
                <div class="ui-ddsection ui-assignedtoList" v-if="App.users && isUsersPopup">
                  <ul>
                    <li v-for="user in App.users"
                        @click="changeUserStatus(user)">
                      {{ user.user_name }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="lead-details">
        <div class="lead-info-phone">
          <div class="field-title">{{ front.phone }}</div>
          <div class="field-content">
            <a class="phone_number" :class="{'cursorPointer' : isCursorPointer}"
               @click="getCall(0,'','')" href="#">
              <svg-phone/>
            </a>
            <a class="phone_number"
               @click="getCall(1,'','')" href="#">
              <svg-incognito/>
            </a></div>
        </div>
        <div class="lead-info-email">
          <div class="field-title">{{ front.email }}</div>
          <div class="field-content">
            <a class="lead-clickable-elem-color"
               :href="'mailto:'+Lead.info.email">
              {{ Lead.info.email }}
            </a>
          </div>
        </div>
        <div class="lead-info-country">
          <div class="field-title">{{ front.country }}</div>
          <div class="field-content">
            <div>{{ Lead.info.country }} (+02:00 GMT)</div>
            <current-time/>
          </div>
        </div>
        <div class="lead-info-lp">
          <div class="field-title">{{ front.landingPage }}</div>
          <div class="field-content">
            <a class="lead-clickable-elem-color"
               :href="'https://'+Lead.info.landing"
               target="_blank">{{ Lead.info.landing }}</a>
          </div>
        </div>
        <div class="lead-info-regdate">
          <div class="field-title">{{ front.regDate }}</div>
          <div class="field-content">
            {{ Lead.info.createddate }} {{ Lead.info.createdtime }}
          </div>
        </div>
      </div>
    </div>
    <!-- LEAD CLONES -->
    <div class="lead-clones"></div>
  </div>
</template>

<script>
import {front} from "../../../lang/en";
import SvgPhone from "../../../svg/svg-phone";
import SvgIncognito from "../../../svg/svg-incognito";
import CurrentTime from "../../../components/currentTime";

export default {
  name: "LeadViewLeft",
  components: {CurrentTime, SvgIncognito, SvgPhone},
  data() {
    return {
      front: front,
      isStatusPopup: false,
      isUsersPopup: false,
      isCursorPointer: false
    }
  },
  computed: {
    App() {
      let data = this.$store.state.appData;

      if (data.leadstatus) {
        data.leadstatus = data.leadstatus.sort((a, b) => parseInt(a.sortorderid) - parseInt(b.sortorderid));
      }

      return data;
    }
  },
  methods: {
    openCb() {
      window.open(`${window.location.origin}/cb/${this.Lead.info.login}`, '_blank');
    },

    changeLeadStatus(status) {

    },

    changeUserStatus(user) {

    },

    /**
     * @param isIncognito
     * @param service
     * @param extension
     */
    getCall(isIncognito, service, extension) {
      this.isCursorPointer = false;

      let query = {
        leadid: this.Lead.info.id,
        service: service,
        extention: extension
      }

      if (isIncognito) {
        query.isincog = isIncognito;
      }

      this.$store.dispatch('getCall', query).then((result) => {
        this.isCursorPointer = true;

        if (!result.data.result) {
          alert(result.data.message);
        }

        if (result.data.response) {
          $('#csin' + this.Lead.info.id).html(result.data.response); // todo refactoring
          this.setTimeLastCall(this.Lead.info.id); //todo refactoring
          if ($('.lead-view-container').length > 0) {
            let ldUpdate = {
              timetable : result.data.timetable
            };

            this.updateleadDetails(ldUpdate); //todo refactoring
            this.getLeadViewPartials();//todo refactoring
          }
        }

      }).catch((error) => {
        console.error('getCall: ' + JSON.stringify(error));
      })
    },
  }
}
</script>

<style lang="scss">
.cursorPointer {
  cursor: pointer;
}
</style>
